import { FeatureFlag } from '../FeatureFlag';

export const enableFeatureFlagDevTools = new FeatureFlag({
    key: 'enable-feature-flag-dev-tools',
    defaultValue: false,
});
